import apiInst from '../api.js';
import ProductRegistration from './productRegistration.js';
import axios from 'axios';
import { i18n } from '../../i18n.js';
axios.defaults.headers.common['X-Source-App'] = 'OrderPortal';

class ProductService {
  constructor() {
    console.log('Product service inst');
  }

  getBrands() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.get(`/product/brands/${GLN}`);
  }



  getMarkets() {
    return apiInst.get('/product/markets');
  }

  getRetailers() {
    return apiInst.get(`/product/retailers`);
  }

  productEdit(transactionId, product){
    console.log('productInformation', product)
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    const payload = {
      metaData: {
        userId: 100234,
        informationProvider: GLN
      },
      productInformation: {
        "basicInformation": {
          "productArticleNumber": product.productInformation.productArticleNumber,
          "productBrandName": product.productInformation.productBrandName,
          "productName": product.productInformation.productName,
          "productStartDate": this.formatDate(product.productInformation.productStartDate),
          "productTargetMarkets": product.productInformation.productTargetMarkets.map((item) => item.code),
      },
      "extendedInformation": product.productInformation.extendedInformation,
      },
      productPackagingHierarchy: product.productPackagingHierarchy,
    };
    console.log('productInformation', payload)
    return apiInst.post(`/product/update/${transactionId}`, payload);
  }

  formatDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  }

  productRegistration(productList) {
    let mappedList = ProductRegistration.mapping(productList);
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/register', {
      metaData: {
        userId: 100234,
        informationProvider: GLN
      },
      productList: [...mappedList]
    });
  }

  async getIncompleteRegistration() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/incompleteRegistration/${GLN}`);
      console.log('GET INCOMPLETE REGISTRATION', res.data.data)
      return ProductRegistration.parseDashboardData(res.data.data);
    } catch (e) {
      console.log('GET INCOMPLETE REGISTRATION', e);
    }
  }

  async getIncompleteMarketing() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/incompleteMarketing/${GLN}`);
      return ProductRegistration.parseMarketingData(res.data.data);
    } catch (e) {
      console.log('GET INCOMPLETE MARKETING', e);
    }
  }


  getPackagingType(pkgType) {
    try {
      return apiInst.get(`/product/${pkgType}`);
    } catch (e) {
      return e;
    }
  }

  saveLogisticsInfo(payload) {
    const { id, logisticsInformation, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    let replacedLogisticsInformation = JSON.parse(
      JSON.stringify(logisticsInformation, (key, value) => (value === '' ? null : value))
    );
    return apiInst.post('/product/logistics', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: false
      },
      logisticsInformation: replacedLogisticsInformation
    });
  }

  finalizeLogistics(payload) {
    const { id, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/logistics/finalize', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: true
      }
    });
  }

  validateLogistics(payload) {
    const { id, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/logistics/complete', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: true
      }
    });
  }

  finalizeTradeitem(transactionId) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post(`/product/finalize/${transactionId}`, {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
      }
    });
  }

  deleteTradeitem(transactionId) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.delete(`/product/remove/${transactionId}`, {
      data: {
        metaData: {
          userId: 100234,
          informationProvider: GLN,
        }
      }
    });
  }

  submitPublication(payload) {
    const { id, variantIndex, informationProviders } = payload;

    return apiInst.post('/product/publication', {
      _id: id,
      variantIndex,
      informationProviders
    });
  }

  submitBatchPublication(payload) {
    return apiInst.post('/product/publication/batched', {
      batchedPublication: payload
    });
  }

  storePublicationBatched(payload) {

    return apiInst.post('/product/publication/batched/store', {
      batchedPublication: payload
    });
  }

  downloadTemplate() {
    const lang = i18n.locale || 'nl';
    return apiInst.get(`/template/product/xxtract?lang=${lang}`);
  }
  downloadPackagingTemplate() {
    return apiInst.get('/template/packaging');
  }
  downloadMarketingTemplate() {
    return apiInst.get('/template/marketing');
  }

  uploadPackagingFile(payload, name) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.post('/import/packaging', {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        filename: name,
        userLang: i18n.locale
      },
      content: payload
    });
  }

  uploadMarketingFile(payload, name) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.post('/import/marketing', {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        filename: name,
        userLang: i18n.locale
      },
      content: payload
    });
  }


  uploadProductFile(payload, name, services, urgent) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.post('/product/spreadsheet', {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        filename: name,
        userLang: i18n.locale,
        services: services,
        urgent: urgent
      },
      content: payload
    });
  }

  uploadCustomProductFile(payload, name, services, urgent) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.post('/product/customSpreadsheet', {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        template: "SuperunieProductRegistrationTemplate_v1_nl",
        filename: name,
        userLang: i18n.locale,
        services: services,
        urgent: urgent
      },
      content: payload
    });
  }

  batchRemove(productIds) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.delete('/product/batch-remove', {
      data: {
        userId: 100234,
        informationProvider: GLN, 
        documentIds: productIds
      }
    });
  }

  async getHistory() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/completedRegistration/${GLN}`);
      console.log('GET COMPLETE REGISTRATION - HISTORY', res.data.data)
      return ProductRegistration.parseHistoryData(res.data.data);
    } catch (e) {
      console.log('GET COMPLETE REGISTRATION - HISTORY', e);
    }
  }

  submitMarketingInfo(payload) {
    const uniqueSellingPoints = [];
    const description = [];
    const keywords = [];
    //TODO the language in future will be dynamic
    const language = 'nl';
    const { id, uspList, productDescription, keywordsList } = { ...payload };

    if (uspList && uspList.length) {
      let uspContent = uspList.map((item) => item.info);
      uspContent = uspContent.length == 1 && uspContent[0] == null ? null : uspContent;

      if (uspContent) {
        uniqueSellingPoints.push({ language, content: uspContent });
      }
    }

    if (productDescription.length) {
      description.push({ language, content: productDescription });
    }

    if (keywordsList.length) {
      keywords.push({ language, content: keywordsList.join(',') });
    }

    return apiInst.post('/product/marketing', {
      _id: id,
      marketingInformation: {
        uniqueSellingPoints,
        description,
        keywords
      }
    });
  }

  finalizeMarketing(_id) {
    return apiInst.post('/product/marketing/finalize', { _id });
  }

  uploadLabelFiles(hierarchyKeys, files) {
    const formData = new FormData();

    formData.append('hierarchyKeys', JSON.stringify(hierarchyKeys)); // Convert hierarchyKeys to JSON string
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    return axios.post(process.env.VUE_APP_MEDIA_URL + '/customers-label', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  changeLabelStatus(id, labelFilesCount) {
    return apiInst.patch(`/product/status/label`, {
      documentId: id,
      newStatus: 'received',
      labelFilesCount
    });
  }

  changeShipmentStatus(id, status){
    return apiInst.patch(`/product/status/shipment`, { 
      "documentId": id,
      "newStatus": status
     });
  }

  async addServices(products, services) {
    return await apiInst.patch('/product/services/update', {
      selectedProducts: products,
      ...services
    });
  }
}

export default new ProductService();
